<template>
    <div>
        <el-dialog title="Generar comprobante desde múltiples notas"
                   :visible="show"
                   @open="onOpened"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   @close="onClose">
            <div class="row">
                <div class="col-6">
                    <el-select v-model="form.person_id"
                               filterable
                               remote
                               reserve-keyword
                               clearable
                               placeholder="Ingrese uno más caracteres"
                               :remote-method="searchPersons"
                               :loading="loading"
                               @change="changePerson">
                        <el-option v-for="item in persons"
                                   :key="item.id"
                                   :label="item.text"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </div>
                <div class="col-3">
                    <el-date-picker v-model="form.date_start"
                                    type="date"
                                    style="width: 100%"
                                    placeholder="Inicio Fecha de emisión"
                                    :clearable="false"
                                    format="dd/MM/yyyy"
                                    value-format="yyyy-MM-dd"
                                    @change="changeDateStart">
                    </el-date-picker>
                </div>
                <div class="col-3">
                    <el-date-picker v-model="form.date_end"
                                    type="date"
                                    style="width: 100%"
                                    placeholder="Final Fecha de emisión"
                                    :clearable="false"
                                    format="dd/MM/yyyy"
                                    value-format="yyyy-MM-dd"
                                    @change="changeDateEnd">
                    </el-date-picker>
                </div>
                <!--                <div class="col-1">-->
                <!--                    <el-button class="btn-block"-->
                <!--                               type="primary"-->
                <!--                               style="width: 50px"-->
                <!--                               :disabled="!form.person_id"-->
                <!--                               @click="searchNotes">-->
                <!--                        <i class="fa fa-search"></i>-->
                <!--                    </el-button>-->
                <!--                </div>-->
            </div>
            <div class="row mt-3">
                <div class="col-12">
                    <div class="table-responsive" v-if="notes.length > 0">
                        <div class="font-weight-bold">Seleccione una o más notas de venta para poder continuar</div>
                        <div v-if="errors.notes_id" class="alert alert-warning" role="alert">
                            {{ errors.notes_id[0] }}
                        </div>
                        <table class="table table-hover table-stripe">
                            <thead>
                            <tr>
                                <th></th>
                                <th>Número</th>
                                <th class="text-center">F.Emisión</th>
                                <th class="text-right">Monto</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="row in notes" :key="row.id">
                                <td>
                                    <el-switch v-model="row.selected"
                                               @change="changeRowSelected"></el-switch>
                                </td>
                                <td>{{ row.number }}</td>
                                <td class="text-center">{{ row.date_of_issue }}</td>
                                <td class="text-right">{{ row.total_label }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-else>
                        <span v-if="form.person_id">No se encontraron notas de venta con el criterio de búsqueda.</span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-4">
                    <div style="font-size: 18px" v-if="notes.length > 0">Total: {{ total }}</div>
                </div>
                <div class="col-8 text-right">
                    <el-button :disabled="loading" @click="onClose">Cerrar</el-button>
                    <el-button v-if="selected.length > 0"
                               type="primary"
                               :disabled="loading"
                               @click="onFetchNoteItems">Generar CPE
                    </el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'SaleNoteMultipleGenerateCpe',
    props: {
        show: {
            required: true,
            type: Boolean,
        },
    },
    data() {
        return {
            title: "",
            loading: false,
            persons: [],
            form: {
                person_id: null,
                date_start: moment().startOf('month').format('YYYY-MM-DD'),
                date_end: moment().format('YYYY-MM-DD'),
            },
            selected: [],
            notes: [],
            errors: {},
            group_items_generate_document: false,
            total: 0,
        };
    },
    methods: {
        getObjectForNote(data) {
            return {
                number_full: `${data.series}-${data.number}`,
                id: data.id,
                items: data.items,
            }
        },
        onFetchNoteItems() {
            if (this.selected.length === 0) {
                this.$message({
                    message: "Seleccione una o más notas de venta por favor",
                    type: "warning",
                });
                return;
            }
            this.loading = true;
            if (this.group_items_generate_document) {
                const data = {
                    notes_id: this.selected,
                };
                this.$http
                    .post("/sale-notes/items", data)
                    .then((response) => {
                        const notes = [];
                        this.notes.map((d) => {
                            if (d.selected) {
                                notes.push(this.getObjectForNote(d))
                            }
                        });
                        const items = response.data.data;
                        const data = [];
                        items.map((i) => {
                            const it = {
                                id: i.item_id,
                                quantity: 0,
                            };
                            items.map((ite) => {
                                if (ite.item_id === it.id) {
                                    it.quantity = it.quantity + parseFloat(ite.quantity);
                                }
                            });
                            const itemIsDuplicated = data.find((item) => item.id === it.id);
                            if (itemIsDuplicated) {
                                itemIsDuplicated.quantity = it.quantity;
                            } else {
                                data.push(it);
                            }
                        });
                        const client = this.persons.find((c) => c.id === this.form.person_id);
                        localStorage.setItem("client", JSON.stringify(client));
                        localStorage.setItem("itemsForNotes", JSON.stringify(data));
                        localStorage.setItem("notes", JSON.stringify(notes));
                        this.onClose();
                        window.location.href = "/documents/create";
                    })
                    .catch((error) => this.axiosError(error))
                    .finally(() => (this.loading = false));

            } else {
                this.processNotGroupItems()
            }
        },
        processNotGroupItems() {
            const data = {
                notes_id: this.selected,
                select_all: true
            };
            this.$http.post("/sale-notes/items", data)
                .then((response) => {
                    const notes = [];
                    this.notes.map((d) => {
                        if (d.selected) {
                            notes.push(this.getObjectForNote(d))
                        }
                    });
                    const items = response.data.data;
                    const client = this.persons.find((c) => c.id === this.form.person_id);
                    localStorage.setItem("client", JSON.stringify(client));
                    localStorage.setItem("itemsNotGroupForNotes", JSON.stringify(items));
                    localStorage.setItem("notes", JSON.stringify(notes));
                    this.onClose();
                    window.location.href = "/documents/create";
                })
                .catch((error) => this.axiosError(error))
                .finally(() => (this.loading = false));
        },
        changeRowSelected() {
            this.selected = [];
            this.total = 0;
            let total = 0;
            this.notes.map((d) => {
                if (d.selected) {
                    total += d.total;
                    this.selected.push(d.id);
                }
            });
            this.total = _.round(total, 2);
        },
        searchPersons(input) {
            this.loading = true;
            this.persons = [];
            this.notes = [];
            this.selected = [];
            this.$http.post("/store/get_simple_customers", {input: input})
                .then((response) => {
                    this.persons = response.data;
                })
                .finally(() => (this.loading = false));
        },
        onOpened() {
            this.form.person_id = null;
            this.searchPersons('');
            this.getConfigGroupItems();
        },
        getConfigGroupItems() {
            this.$http.get("/sale-notes/config-group-items")
                .then((response) => {
                    this.group_items_generate_document = response.data.group_items_generate_document
                })
        },
        async changePerson() {
            await this.searchNotes();
        },
        async changeDateStart() {
            if (this.form.date_start > this.form.date_end) {
                this.form.date_end = this.form.date_start
            }
            await this.searchNotes();
        },
        async changeDateEnd() {
            if (this.form.date_end < this.form.date_start) {
                this.form.date_start = this.form.date_end
            }
            await this.searchNotes();
        },
        async searchNotes() {
            this.notes = [];
            this.selected = [];
            this.loading = true;
            await this.$http.post(`/sale_notes/search_by_person_id`, this.form)
                .then((response) => {
                    this.notes = response.data;
                })
                .finally(() => (this.loading = false));
        },
        onClose() {
            this.$emit("update:show", false);
        },
    },
};
</script>
